import type { IServiceMap } from '../services';

export const PremiumOnboarding: IServiceMap = {
  setup: {
    accountAndWorkspaceSetup: true,
    pixelInstallationUpTo3Domains: true,
    groupCreation: 5,
    customDataRequests: 2,
    conversionPixels: 2,
    contactRecordImports: 2,
    dataImportAndListCleaning: false,
  },
  calls: {
    dedicatedFlightManagementTeam: false,
    quarterlyReview: false,
    kickOffAndFinalReport: false,
    liveTrainingSessions: '5/90d',
    liveStrategist: false,
    dedicatedSupportRep: false,
  },
  implementations: {
    implementationsPageVisible: '90d',
  },
  creatives: {
    credits: 5,
    creativeABTesting: false,
    starterSet: false,
  },
  execution: {
    flightSetupAndManagement: false,
    biweeklyHealthChecks: false,
    liveCampaignReportLinks: false,
    reusableFlightTemplate: false,
    formattedFinalReport: false,
  },
};
